import { c as _c } from "react/compiler-runtime";
import { selectedProjectSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { hasUserValidPermissionProjectLevel } from "@utils/permission-control/project-permission-control";
import { RequiredPermissionProjectLevelName } from "@utils/permission-control/project-permission-control-types";
import { useCallback, useMemo } from "react";
/** Checks whether a user has permission for an action on project level or not */
export function useHasUserValidPermissionProjectLevel(t0) {
  const $ = _c(54);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    project: t2
  } = t1;
  const project = t2 === undefined ? null : t2;
  const selectedProjectInStore = useAppSelector(selectedProjectSelector);
  const selectedProject = project || selectedProjectInStore;
  let t3;
  if ($[2] !== selectedProject) {
    t3 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canChangeRole,
      selectedProject
    });
    $[2] = selectedProject;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const canChangeRole = t3;
  let t4;
  if ($[4] !== selectedProject) {
    t4 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canChangeProjectGroup,
      selectedProject
    });
    $[4] = selectedProject;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const canChangeProjectGroup = t4;
  let t5;
  if ($[6] !== selectedProject) {
    t5 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canChangeProjectAccessLevel,
      selectedProject
    });
    $[6] = selectedProject;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const canChangeProjectAccessLevel = t5;
  let t6;
  if ($[8] !== selectedProject) {
    t6 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canEditProjectDetails,
      selectedProject
    });
    $[8] = selectedProject;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const canEditProjectDetails = t6;
  let t7;
  if ($[10] !== selectedProject) {
    t7 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canViewProjectCloudActivity,
      selectedProject
    });
    $[10] = selectedProject;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const canViewProjectCloudActivity = t7;
  let t8;
  if ($[12] !== selectedProject) {
    t8 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canViewAllProjectMembers,
      selectedProject
    });
    $[12] = selectedProject;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const canViewAllProjectMembers = t8;
  let t9;
  if ($[14] !== selectedProject) {
    t9 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canViewProjectSettings,
      selectedProject
    });
    $[14] = selectedProject;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const canViewProjectSettings = t9;
  let t10;
  if ($[16] !== selectedProject) {
    t10 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canInviteUsersToPrivateProject,
      selectedProject
    });
    $[16] = selectedProject;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const canInviteUsersToPrivateProject = t10;
  let t11;
  if ($[18] !== selectedProject) {
    t11 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canInviteMembersToSnapshot,
      selectedProject
    });
    $[18] = selectedProject;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const canInviteMembersToSnapshot = t11;
  let t12;
  if ($[20] !== selectedProject) {
    t12 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canEditProjectSettings,
      selectedProject
    });
    $[20] = selectedProject;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const canEditProjectSettings = t12;
  let t13;
  if ($[22] !== selectedProject) {
    t13 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canDeleteMemberFromProject,
      selectedProject
    });
    $[22] = selectedProject;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const canDeleteMemberFromProject = t13;
  let t14;
  if ($[24] !== selectedProject) {
    t14 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canDeleteProject,
      selectedProject
    });
    $[24] = selectedProject;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const canDeleteProject = t14;
  let t15;
  if ($[26] !== selectedProject) {
    t15 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canViewProjectMarkups,
      selectedProject
    });
    $[26] = selectedProject;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const canViewProjectMarkups = t15;
  let t16;
  if ($[28] !== selectedProject) {
    t16 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canViewProjectMarkupsAllowViewers,
      selectedProject
    });
    $[28] = selectedProject;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const canViewProjectMarkupsAllowViewers = t16;
  let t17;
  if ($[30] !== selectedProject) {
    t17 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canViewProjectsStats,
      selectedProject
    });
    $[30] = selectedProject;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const canViewProjectsStats = t17;
  let t18;
  if ($[32] !== selectedProject) {
    t18 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canEditProjectMarkups,
      selectedProject
    });
    $[32] = selectedProject;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const canEditProjectMarkups = t18;
  let t19;
  if ($[34] !== selectedProject) {
    t19 = hasUserValidPermissionProjectLevel({
      permissionName: RequiredPermissionProjectLevelName.canViewProjectIntegrations,
      selectedProject
    });
    $[34] = selectedProject;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const canViewProjectIntegrations = t19;
  const hasUserPermissionProjectLevel = _temp;
  let t20;
  if ($[36] !== canChangeProjectAccessLevel || $[37] !== canChangeProjectGroup || $[38] !== canChangeRole || $[39] !== canDeleteMemberFromProject || $[40] !== canDeleteProject || $[41] !== canEditProjectDetails || $[42] !== canEditProjectMarkups || $[43] !== canEditProjectSettings || $[44] !== canInviteMembersToSnapshot || $[45] !== canInviteUsersToPrivateProject || $[46] !== canViewAllProjectMembers || $[47] !== canViewProjectCloudActivity || $[48] !== canViewProjectIntegrations || $[49] !== canViewProjectMarkups || $[50] !== canViewProjectMarkupsAllowViewers || $[51] !== canViewProjectSettings || $[52] !== canViewProjectsStats) {
    t20 = {
      canChangeRole,
      canChangeProjectGroup,
      canChangeProjectAccessLevel,
      canEditProjectDetails,
      canViewProjectCloudActivity,
      canViewAllProjectMembers,
      canViewProjectSettings,
      canInviteUsersToPrivateProject,
      canInviteMembersToSnapshot,
      canEditProjectSettings,
      canDeleteMemberFromProject,
      canDeleteProject,
      canViewProjectMarkups,
      canViewProjectMarkupsAllowViewers,
      canViewProjectsStats,
      canEditProjectMarkups,
      canViewProjectIntegrations,
      hasUserPermissionProjectLevel
    };
    $[36] = canChangeProjectAccessLevel;
    $[37] = canChangeProjectGroup;
    $[38] = canChangeRole;
    $[39] = canDeleteMemberFromProject;
    $[40] = canDeleteProject;
    $[41] = canEditProjectDetails;
    $[42] = canEditProjectMarkups;
    $[43] = canEditProjectSettings;
    $[44] = canInviteMembersToSnapshot;
    $[45] = canInviteUsersToPrivateProject;
    $[46] = canViewAllProjectMembers;
    $[47] = canViewProjectCloudActivity;
    $[48] = canViewProjectIntegrations;
    $[49] = canViewProjectMarkups;
    $[50] = canViewProjectMarkupsAllowViewers;
    $[51] = canViewProjectSettings;
    $[52] = canViewProjectsStats;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  return t20;
}
function _temp(t0) {
  const {
    permissionName,
    project: t1
  } = t0;
  const project_0 = t1 === undefined ? null : t1;
  return hasUserValidPermissionProjectLevel({
    permissionName,
    selectedProject: project_0
  });
}